import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import SideBar from "../Sidebar/Sidebar";
import sidebar_menu from "../../Constants/Sidebar-menu";
import "./DashBoard.css";
import Users from "../../pages/Admin/Users/Users";
import Hospital from "../../pages/Admin/Hospitals/Hospitals";
import Gosi from "../../pages/Admin/Gosi/Gosi";
import Notice from "../../pages/Admin/Notice/Notice";
import Patient from "../../pages/Admin/Patient/Patient";
import Community from "../../pages/Admin/Community/Community";
import UserManagement from "../../pages/Admin/UserManagement/UserManagement";

function DashBoard() {
  return (
    <div className="dashboard-container">
      <SideBar menu={sidebar_menu} />

      <div className="dashboard-body">
        <Routes>
          <Route path="*" element={<Users />} />
          <Route exact path="/users" element={<Users />} />
          <Route exact path="/user-management" element={<UserManagement />} />
          <Route exact path="/hospital" element={<Hospital />} />
          <Route exact path="/patient" element={<Patient />} />
          <Route exact path="/gosi" element={<Gosi />} />
          <Route exact path="/notice" element={<Notice />} />
          <Route exact path="/patient-community" element={<Community />} />
        </Routes>
      </div>
    </div>
  );
}

export default DashBoard;
